import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { CustomersService } from '../services/customers.service';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { Customer } from '../../dto/customer';
import {
  formatPhoneNumeric,
  parseDateToServerDateOffset,
  toDateString,
  toDateTimeString
} from '../../providers/app-date-adapter';
import {Order} from '../../dto/order';
import {FormControl} from '@angular/forms';
import {IdentStatus} from '../../dto/ident-status';
import {environment} from '../../../environments/environment';
import {CompanyService} from '../services/company.service';
import {Company} from '../../dto/company';
import {IdvCustomersService} from '../services/idv-customers.service';
import {RiskService} from '../services/risk.service';

@Component({
  selector: 'app-idv-customers-overview',
  templateUrl: './idv-customers-overview.component.html',
  styleUrls: ['./idv-customers-overview.component.css']
})
export class IdvCustomersOverviewComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private idvCustomersService: IdvCustomersService,
    public companiesService: CompanyService,
    private riskService: RiskService

  ) { }



  public webIdStatusSelect = new FormControl();
  public companySelect = new FormControl();
  public companies: Company[];
  public webIdStatus = IdentStatus;
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.idvCustomersService);
  columns = [

    { columnDef: 'tokens', header: 'Token(s)', cell: (row: Customer) => {
        if ( !row.cards) {
return '(none)';
}
        let tokensString = '';
        row.cards.forEach((card) => {
          tokensString += card.token.toString()+'\n';
        });
        tokensString = tokensString.trimRight();
        return tokensString;
      }
    },
    { columnDef: 'title', header: 'Title', cell: (row: Customer) => `${row.title}` },
    { columnDef: 'firstName', header: 'First name', cell: (row: Customer) => `${row.firstName}` },
    { columnDef: 'lastName', header: 'Last name', cell: (row: Customer) => `${row.lastName}` },
    { columnDef: 'address', header: 'Address', cell: (row: Customer) => `${row.address}` },
    { columnDef: 'city', header: 'City', cell: (row: Customer) => `${row.city}` },
    { columnDef: 'zipCode', header: 'Zip code', cell: (row: Customer) => `${row.zipCode}` },
    { columnDef: 'email', header: 'Email', cell: (row: Customer) => `${row.email}` },
    { columnDef: 'phone', header: 'Mobile', cell: (row: Customer) => `${formatPhoneNumeric(row.phone)}` },
    { columnDef: 'dob', header: 'Date of birth', cell: (row: Customer) => `${toDateString(row.dob)}` },
    { columnDef: 'Partner', header: 'Partner', cell: (row: Customer) => row.orders.length > 0 ? row.orders[0].companyName : '' },
    { columnDef: 'partnerCustomerId', header: 'Partner-ID', cell: (row: Customer) => this.getPartnerId(row) },
    // { columnDef: "countryName", header: "Country", cell: (row: Customer) => `${row.countryName}` },
    // TODO if solr is rdy comment it in
    // { columnDef: "cardsCount", header: "Cards", cell: ( row: Customer ) => `${ row.cards.length }` },

  ];

  ngOnInit() {
    this.getActiveRiskInquiries();
    this.companiesService.getAll().subscribe( x => {
      this.companies = x.data;
    });
  }

  activeInquiries = 0;
  getActiveRiskInquiries() {
    if (!this.currentUserIsPartner()) {
      this.riskService.getActiveInquiries().subscribe(result => {
        this.activeInquiries = result;
      });
    }
  }



  onCompanyChange() {
    this.table.filters.someAdditionalData = 'companyid_' + this.companySelect.value; // TODO heavy abuse
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  getPartnerId(row: Customer){
    let r = '';
    let c = 0;
    const array = row.orders.filter(x=> x.partnerCustomerId != null);
    const resArr = [];

    if(array.length > 0){
      row.orders.forEach((item) =>{
        const i = resArr.findIndex(x => x.partnerCustomerId == item.partnerCustomerId);
        if(i <= -1){
          if(c > 0){
            r = r + ', ';
          }
          resArr.push({id: item.id, name: item.partnerCustomerId});
          r = item.partnerCustomerId;
          c++;
        }

      });
    }


    return r == '' ? '-' : r;
  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsAdminOrCompliance(){

    if( this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance') ) {
return true;
}

    return false;

  }

  currentUserIsAdminOrManagerOrCompliance(){

    if( this.roleService.hasRoles('admin') || this.roleService.hasRoles('manager') || this.roleService.hasRoles('compliance') ) {
return true;
}

    return false;

  }

  getViewLink = (item: Customer): string => item.id.toString();

  getEditLink = (item: Customer): string => item.id.toString() + '/edit';

  editEnabled() {
    return this.roleService.hasRoles(['admin', 'manager']);
  }

  deleteEnabled() {
    return false;
  }

}
